import { useTranslation } from "../i18n";
import DashboardAdmin from "../components/DashboardAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

const AdminDashboard = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide admin-dashboard-page" style={{ height: "calc(100vh - 56px)", overflowY: "auto", overflowX: "hidden" }}>
            <AdminPageHeader
                titleKey="dashboard_admin_title"
                backTo="/admin"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "dashboard_admin_title" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("dashboard_admin_hint")}</p>
                <DashboardAdmin />
            </div>
        </div>
    );
};

export default AdminDashboard;
